import { Component, OnInit } from '@angular/core';
import { AdManagementService } from 'src/app/services/ad-management/ad-management.service';
import { Ad } from 'src/app/models/ad';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'ad-listing',
  templateUrl: './ad-listing.component.html',
  styleUrls: ['./ad-listing.component.scss'],
  providers: [AdManagementService]
})

export class AdListingComponent implements OnInit {
  public ads: Ad[];
  public transactiontype: string;
  public estatetype: string;

  public constructor(
    private adManagementService: AdManagementService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route
      .queryParamMap
      .pipe(
        switchMap(
          (params: ParamMap) => {
            this.transactiontype = params.get('transactiontype');
            this.estatetype = params.get('estatetype');
            return this.adManagementService.getfilteredPublicAds(this.transactiontype, this.estatetype);
          }))
      .subscribe(
        list =>
          this.ads = list.sort((ad1, ad2) => ad1.price - ad2.price));
  }
}
